import { render, staticRenderFns } from "./BlogArticlesList.vue?vue&type=template&id=0946e770&scoped=true"
import script from "./BlogArticlesList.js?vue&type=script&lang=js&external"
export * from "./BlogArticlesList.js?vue&type=script&lang=js&external"
import style0 from "./BlogArticlesList.scss?vue&type=style&index=0&id=0946e770&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0946e770",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticleTeaser: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/articles/ArticleTeaser/ArticleTeaser.vue').default,LatestArticles: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/articles/LatestArticles/LatestArticles.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,NewsletterBanner: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/NewsletterBanner/NewsletterBanner.vue').default,Pagination: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Pagination/Pagination.vue').default,RelatedLinks: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/RelatedLinks/RelatedLinks.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
